import { DEFAULT_DATE_FORMAT, DEFAULT_EMPTY_VALUE } from 'utils/constants';
import { getItemOrDefaultToValue } from 'utils/details';
import { displayTime } from 'utils/time';
import { translateStringAfterSlash } from 'utils/methods/helpers';

export const transformSubscriptions = (subscriptions, paymentType) => {
  if (!subscriptions) return [];
  return subscriptions.map(data => ({
    id: data.planId,
    amountDue: !paymentType
      ? ''
      : paymentType === 'Invoiced'
      ? 'Invoiced'
      : translateStringAfterSlash(data.amount),
    productName: data.displayName,
    nextBillingDate: data.nextBillingDate
      ? displayTime({
          timestamp: data.nextBillingDate,
          format: DEFAULT_DATE_FORMAT,
        })
      : DEFAULT_EMPTY_VALUE,
    planEndDate: data.willCancelAt
      ? displayTime({
          timestamp: data.willCancelAt,
          format: DEFAULT_DATE_FORMAT,
        })
      : DEFAULT_EMPTY_VALUE,
    pendingPlan: data.willChangeToPlan
      ? getItemOrDefaultToValue(
          data.willChangeToPlan,
          'productName',
          DEFAULT_EMPTY_VALUE,
        )
      : '-',
    pendingPlanStartDate: data.willUpdateAt
      ? displayTime({
          timestamp: data.willUpdateAt,
          format: DEFAULT_DATE_FORMAT,
        })
      : DEFAULT_EMPTY_VALUE,
  }));
};
